import { ImageComponent as _ImageComponent } from "./BasicImageConfig";
export { default } from "./BasicImageConfig";
export type ImageComponent = _ImageComponent;
